import ArrowIcon from '../../assets/logos/arrow.svg?raw';

interface DashboardCardProps {
  id: number
  name: string
  description: string
  slug: string
  onSelectDashboard: (id: number) => void
}

export default function DashboardCard({ id, name, description, onSelectDashboard }: DashboardCardProps) {
    const viewDashboard = () => {
      onSelectDashboard(id)
    }

  return (
    <div 
      className="cursor-pointer bg-white rounded-xl shadow-sm border border-gray-200 px-4 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
      onClick={viewDashboard}
    >
      {/* Texto */}
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-semibold text-gray-800">{name}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>

      {/* Flecha */}
      <div 
        dangerouslySetInnerHTML={{ __html: ArrowIcon }}
        className="svg-container"
      />
    </div>
  )
}